import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts';
import { Stack } from '@mui/material';
import { ChartTitle } from './ChartTitle';
import {
  rslDonutChartOptions,
  RslDonutChartOptionsProps,
} from '../../configuration/donutChartOptions';

type DonutChartWithTitleProps = RslDonutChartOptionsProps & {
  title: string;
};

export const DonutChartWithTitle = (props: DonutChartWithTitleProps) => {
  const { title, ...donutChartOptionsProps } = props;
  return (
    <Stack direction="column" gap="1rem">
      <ChartTitle title={title} />
      <HighchartsReact
        highcharts={Highcharts}
        options={rslDonutChartOptions(donutChartOptionsProps)}
      />
    </Stack>
  );
};
